import React from "react";
import { Link } from "react-router-dom";

const PageNotFound = () => {
  return (
    <div className="bg-white d-flex flex-column align-items-center justify-content-center p-4 min-vh-100 font-inter">
      <div className="w-100" style={{ maxWidth: "768px", textAlign: "center" }}>
        <h1 className="display-1 fw-bold text-secondary mb-4">404</h1>

        <div
          className="position-relative mb-5 mt-3 mx-auto"
          style={{ width: "280px", height: "280px" }}
        >
          <div
            className="w-100 h-100 bg-center bg-no-repeat bg-contain float-animation"
            style={{
              backgroundImage:
                "url('https://readdy.ai/api/search-image?query=friendly%20medical%20professional%20character%20in%20white%20coat%20with%20stethoscope%2C%20looking%20concerned%2C%20cartoon%20style%2C%20simple%20background%2C%20minimalist%20design%2C%20soft%20colors%2C%20healthcare%20themed&width=280&height=280&seq=1&orientation=squarish')",
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
            }}
          ></div>

          {[
            "20% 15%",
            "30% auto 0 20%",
            "auto 0 25% 25%",
            "auto 15% 15% auto",
          ].map((pos, i) => (
            <div
              key={i}
              className="position-absolute bg-warning rounded-circle opacity-50"
              style={{
                width: "8px",
                height: "8px",
                boxShadow: "0 0 8px rgba(198, 153, 51, 0.8)",
                animation: "pulse 1.5s ease-in-out infinite",
                animationDelay: `${i * 0.3}s`,
                inset: pos,
              }}
            ></div>
          ))}
        </div>

        <h2 className="h4 fw-semibold text-dark mb-3">Oops! Page Not Found</h2>
        <p className="text-muted mb-4 mx-auto" style={{ maxWidth: "480px" }}>
          We couldn't find the page you're looking for. Don't worry - our
          medical team is on the case! Let's get you back to a healthy path.
        </p>
        <Link
          to="/home"
          className="btn text-white px-4 py-3 d-inline-flex align-items-center shadow-sm"
          style={{
            backgroundColor: "  #c69933",
          }}
        >
          <i className="ri-heart-pulse-line me-2"></i>
          Return to Homepage
        </Link>

        <div className="mt-5 text-muted small">
          <p>
            If you believe this is an error, please{" "}
            <Link
              to="/contact-us/"
              style={{ color: "#c69933", textDecoration: "underline" }}
            >
              contact our support team
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PageNotFound;
